import { render } from "./IconPlus.vue?vue&type=template&id=7539fdba&scoped=true"
const script = {}

import "./IconPlus.vue?vue&type=style&index=0&id=7539fdba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7539fdba"]])

export default __exports__